import { css } from '@lastbrand/web-ui-styled-system/css'

export const wrapperBaseClass = css({
  width: 'full',
  borderTop: '1px solid',
  borderColor: 'lightgray',
  paddingTop: 'space-40',
  marginTop: 'space-40',
  lgDown: {
    marginBottom: 'space-20',
  },
})

export const contentBaseClass = css({
  textStyle: 'body-14',
  color: 'black',
  '& a': {
    borderBottom: '1px solid',
    borderColor: 'black',
  },
})

export const iconsWrapperClass = css({
  my: 'space-24',
})
